export const CURRENCY_DELETE_CURRENCY_BEGIN = 'CURRENCY_DELETE_CURRENCY_BEGIN';
export const CURRENCY_DELETE_CURRENCY_SUCCESS = 'CURRENCY_DELETE_CURRENCY_SUCCESS';
export const CURRENCY_DELETE_CURRENCY_FAILURE = 'CURRENCY_DELETE_CURRENCY_FAILURE';
export const CURRENCY_DELETE_CURRENCY_DISMISS_ERROR = 'CURRENCY_DELETE_CURRENCY_DISMISS_ERROR';
export const CURRENCY_SAVE_CURRENCY_BEGIN = 'CURRENCY_SAVE_CURRENCY_BEGIN';
export const CURRENCY_SAVE_CURRENCY_SUCCESS = 'CURRENCY_SAVE_CURRENCY_SUCCESS';
export const CURRENCY_SAVE_CURRENCY_FAILURE = 'CURRENCY_SAVE_CURRENCY_FAILURE';
export const CURRENCY_SAVE_CURRENCY_DISMISS_ERROR = 'CURRENCY_SAVE_CURRENCY_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/currency/redux/constants.js